"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.number.constructor");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _vuexClass = require("vuex-class");

var _authentication = require("@/mixins/authentication/authentication");

var _common = require("@/mixins/common/common");

var _loading = require("@/mixins/loading/loading");

var _railway = require("@/mixins/railway/railway");

var _elementUi = require("element-ui");

var _locationTimeline = _interopRequireDefault(require("./location-timeline.scss"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LocationTimelineComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LocationTimelineComponent, _Mixins);

  var _super = _createSuper(LocationTimelineComponent);

  function LocationTimelineComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LocationTimelineComponent);
    _this = _super.apply(this, arguments);
    _this.locationList = [];
    return _this;
  }

  (0, _createClass2.default)(LocationTimelineComponent, [{
    key: "onOrderDataChanges",
    value: function onOrderDataChanges(newVal) {
      if (!!newVal.length) {
        this.locationList = this.getLocationList(newVal[0]['routeData']);
      }
    }
  }, {
    key: "containerStyle",
    get: function get() {
      return {
        // height: this.containerHeight,
        top: 0
      };
    }
  }, {
    key: "rowStyle",
    get: function get() {
      var width = Number(_locationTimeline.default['gps-width']) + Number(_locationTimeline.default['container-width']) + Number(_locationTimeline.default['status-width']) + Number(_locationTimeline.default['type-width']) + (Number(_locationTimeline.default['location-width']) + 34) * this.locationList.length;
      return {
        width: "".concat(width, "px")
      };
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {}
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "getLocationList",
    value: function getLocationList(locations) {
      var _this2 = this;

      var arr = [];
      locations.forEach(function (loc) {
        var waypointId = loc['masterpointId'];
        var orderId = Number(waypointId.split('-')[0]);

        var waypoints = _this2.getOrderInfo(orderId, 'waypoints');

        var waypoint = waypoints.find(function (wp) {
          return wp.id === waypointId;
        });
        var address = '';

        if (waypoint) {
          address = waypoint.remarks;
        }

        arr.push({
          id: loc['id'],
          address: address,
          type: loc['waypointType']
        });
      });
      return arr;
    }
  }, {
    key: "openMap",
    value: function () {
      var _openMap = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(order) {
        var _this3 = this;

        var orderData,
            locations,
            containerNum,
            gpsId,
            selectedData,
            gpsData,
            routeData,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                orderData = _args.length > 1 && _args[1] !== undefined ? _args[1] : [];
                locations = {};

                if (!(orderData.length >= 1)) {
                  _context.next = 23;
                  break;
                }

                if (orderData[0] && orderData[0]['latitude'] && orderData[0]['longitude']) {
                  locations = {
                    latitude: parseFloat(orderData[0]['latitude']),
                    longitude: parseFloat(orderData[0]['longitude'])
                  };
                }

                containerNum = this.helper.get(order, 'additionalData.containerNumber', '');
                gpsId = this.helper.get(order, 'gpsData.deviceId', '');
                selectedData = orderData.map(function (oData) {
                  return oData;
                });
                window.localStorage.setItem('tLocation', this.helper.toString(locations));
                window.localStorage.setItem('tContainerNum', this.helper.toString(containerNum));

                if (!this.helper.isNotEmpty(gpsId)) {
                  _context.next = 17;
                  break;
                }

                window.localStorage.setItem('tGpsId', this.helper.toString(gpsId));
                _context.next = 13;
                return this.railwayAPI.getGpsData({
                  query: "DeviceId:".concat(gpsId)
                });

              case 13:
                gpsData = _context.sent;

                if (gpsData.status === 'success' && gpsData.data && gpsData.data.length >= 1) {
                  gpsData.data.forEach(function (gData) {
                    var latlngKey = 'LatLongG';

                    if (_this3.$userSetting['default10']) {
                      latlngKey = 'LatLongA';
                    } else {
                      latlngKey = 'LatLongG';
                    }

                    var gDataSplit = gData[latlngKey].split(',');
                    selectedData.push({
                      'waypointType': 'R',
                      'latitude': gDataSplit[1] || 0,
                      'longitude': gDataSplit[0] || 0,
                      'address': gData['AddCode']
                    });
                  });
                }

                _context.next = 18;
                break;

              case 17:
                window.localStorage.removeItem('tGpsId');

              case 18:
                window.localStorage.removeItem('tName');
                window.localStorage.setItem('tData', this.helper.toString(selectedData));
                window.localStorage.setItem('tInitEvent', 'marker');
                routeData = this.$router.resolve({
                  name: 'map'
                });
                window.open(routeData.href, containerNum, 'toolbar=no, location=no, status=no, menubar=no, scrollbars=no, resizable=yes, width=600, height=600');

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function openMap(_x) {
        return _openMap.apply(this, arguments);
      }

      return openMap;
    }()
    /*getWaypointClass(data, type?) {
      const classObj = {};
         if (this.helper.isUndefined(type)) {
        if (data.hasFinished) {
          const className = data.isOnTime ? 'on-time' : 'late';
          classObj[className] = true;
        }
      } else {
        if (data.status === 'completed' && data.actualData) {
          const className = data.actualData.endOnTime ? 'on-time' : 'late';
          classObj[className] = true;
        }
      }
         return classObj;
    }*/

  }, {
    key: "getLatestWp",
    value: function getLatestWp(waypoints) {
      var _this4 = this;

      return this.helper.findLast(waypoints, function (wp) {
        return _this4.isWaypointFilledCircle(wp);
      }) || null;
    }
  }, {
    key: "getLatestWpInfo",
    value: function getLatestWpInfo(waypoints, fieldName) {
      var waypoint = this.getLatestWp(waypoints);

      if (!waypoint) {
        return '';
      }

      return waypoint[fieldName];
    }
  }, {
    key: "getLatestWpIndex",
    value: function getLatestWpIndex(waypoints) {
      var _this5 = this;

      return this.helper.findLastIndex(waypoints, function (wp) {
        return _this5.isWaypointFilledCircle(wp);
      });
    }
  }, {
    key: "getWaypointClass",
    value: function getWaypointClass(wpIndex, waypoints) {
      var classObj = {};
      var index = this.getLatestWpIndex(waypoints);

      if (wpIndex === index) {
        classObj['latest'] = true;
      }

      return classObj;
    }
  }, {
    key: "formatTime",
    value: function formatTime(time) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YY-MM-DD HH:mm';

      if (this.helper.isUndefined(time)) {
        return '';
      }

      return this.helper.convertTimezone(time, this.$timezone, format);
    }
  }, {
    key: "getActualTimeRailway",
    value: function getActualTimeRailway(wp) {
      var time = '';

      if (wp.gpsData && !wp.gpsData.hasFinished) {
        time = this.formatTime(wp.gpsData.estimateEndTime, 'YY/MM/DD HH:mm') || '-';
      } else if (wp.gpsData && wp.gpsData.hasFinished) {
        time = this.formatTime(wp.gpsData.actualEndTime, 'YY/MM/DD HH:mm') || '-';
      } else {
        time = '';
      }

      return !this.helper.isUndefined(time) ? time : '-';
    }
  }, {
    key: "isWaypointFilledCircle",
    value: function isWaypointFilledCircle(wp) {
      return wp.waypointType === 'T' && wp.gpsData && (wp.gpsData.hasFinished || wp.gpsData.isRunning) && this.getActualTimeRailway(wp) !== '-' || (wp.waypointType === 'P' || wp.waypointType === 'D') && wp.status === 'completed' && wp.actualData && wp.actualData.endTime;
    }
  }, {
    key: "getForecastValue",
    value: function getForecastValue(waypoint) {
      if (waypoint.waypointType !== 'T') {
        return '-';
      }

      if (!waypoint.gpsData || !waypoint.gpsData.forecastType || !waypoint.gpsData.forecastValue) {
        return '-';
      }

      var symbol = '';

      if (waypoint.gpsData.forecastType === 'add') {
        symbol = '+';
      } else if (waypoint.gpsData.forecastType === 'minus') {
        symbol = '-';
      }

      var time = this.helper.secondsToHms(waypoint.gpsData.forecastValue);
      return "".concat(symbol, " ").concat(time);
    }
  }]);
  return LocationTimelineComponent;
}((0, _vuePropertyDecorator.Mixins)(_authentication.AuthenticationMixin, _common.CommonMixin, _loading.LoadingMixin, _railway.RailwayMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], LocationTimelineComponent.prototype, "$isFullscreen", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: 'daily'
})], LocationTimelineComponent.prototype, "planViewType", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 30
})], LocationTimelineComponent.prototype, "defaultTimeStepper", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 54
})], LocationTimelineComponent.prototype, "cellWidth", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: '600px'
})], LocationTimelineComponent.prototype, "containerHeight", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Array,
  default: []
})], LocationTimelineComponent.prototype, "orderData", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Array,
  default: []
})], LocationTimelineComponent.prototype, "orderInfo", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.InjectReactive)()], LocationTimelineComponent.prototype, "getOrderInfo", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('orderData')], LocationTimelineComponent.prototype, "onOrderDataChanges", null);
LocationTimelineComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LocationTimelineComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-tooltip': _elementUi.Tooltip,
    'el-dialog': _elementUi.Dialog,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-button': _elementUi.Button
  }
})], LocationTimelineComponent);
var _default = LocationTimelineComponent;
exports.default = _default;